import React from "react";
import classNames from "classnames";

import { TabProps } from ".";

interface ContentProps {
  activeTab: string;
  tabs: ReadonlyArray<TabProps>;
  theme?: string;
}

const NullComponent = (): JSX.Element => null;

const Content: React.FC<ContentProps> = ({ activeTab, tabs, theme }: ContentProps): JSX.Element => {
  let InnerContent: React.ComponentType = NullComponent;

  for (const tab of tabs) {
    if (activeTab === tab.name) {
      InnerContent = tab.component;
    }
  }

  let containerClass = "caprx-tabs-container-content";
  if (theme === "purple") {
    containerClass = classNames(containerClass, "caprx-tabs-container-content-purple");
  }

  return (
    <div className={containerClass}>
      <InnerContent />
    </div>
  );
};

export default Content;
